import axios from 'axios'

// TODO: consider moving this to an action in the cart store as it's only used during checkout
export async function createForNewCustomer (data) {
  const { convergeResponse, authToken, salesData, reCaptchaToken, shippingAddress, phoneNumber } = data
  const { ssl_token: sslToken, ssl_exp_date: sslExpDate, ssl_card_number: sslCardNumber } = convergeResponse
  const {
    amount,
    firstName,
    lastName,
    address,
    apartmentNumber,
    city,
    state,
    zip,
    email
  } = salesData
  // TODO: replace this with hubRequest from utilities.js
  return await axios.post(`${process.env.VUE_APP_SERVER}/api/v2/sales/create_for_new_customer`, {
    authToken,
    sslToken: sslToken || null,
    amount,
    firstName,
    lastName,
    address,
    apartmentNumber,
    city,
    state,
    email,
    zip,
    expiration: sslExpDate,
    reCaptchaToken,
    cardLastFour: sslCardNumber.slice(-4),
    shippingAddress,
    phoneNumber
  })
}
